import script from "./weeklyCompensationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./weeklyCompensationView.vue?vue&type=script&setup=true&lang=ts"

import "./weeklyCompensationView.vue?vue&type=style&index=0&id=3a737816&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a737816"]])

export default __exports__